<template>
  <section id="file-list" class="card" :class="{ mobile: rootStore.isMobile }">
    <header v-show="visibleFilesList.length > 0">
      <select-box @action="selectAll" :selected="allFilesSelected"></select-box>
      <h3 @click="selectAll" class="select-all pointer">
        {{ headerText }}
      </h3>
    </header>
    <main :class="{ 'no-files': visibleFilesList.length === 0 }">
      <span
        class="empty-list-message"
        v-if="
          visibleFilesList.length === 0 &&
          (printStoreProducts.length === 0 || standalone)
        "
        >Sleep hier de bestanden die u wilt laten printen of klik op de knop
        Bestanden toevoegen.
      </span>

      <span
        class="empty-list-message-ps"
        v-else-if="
          visibleFilesList.length === 0 && printStoreProducts.length > 0
        "
        >Wilt u ook eigen bestanden printen? Sleep deze dan hier of klik op de
        knop Bestanden toevoegen.
      </span>

      <TransitionGroup tag="ul" class="file-list">
        <li v-for="file in visibleFilesList" :key="file.uuid">
          <file
            :file="file"
            :selected="isSelected(file)"
            @select-file="selectFile"
            @add-to-cart="$emit('add-to-cart', file)"
            @click.native="selectFile(file, 'single')"
            @remove="$emit('remove', file)"
            @update-quantity="updateQuantity($event)"
            :show-cart-button="standalone"
          ></file>
        </li>
      </TransitionGroup>

      <ul class="print-store-list" v-if="!standalone">
        <li
          v-for="(product, index) in printStoreProducts"
          :key="index"
          class="ps-product"
        >
          <print-store-product
            :product="product"
            :editable="true"
            @set-quantity="setPrintStoreQuantity($event, index)"
            @remove="removeProduct(product)"
          ></print-store-product>
        </li>
      </ul>

      <div class="scrolloverlay"></div>
    </main>
    <uploader-btn
      class="add-btn pill-button-lg"
      key="pc"
      id="product-order-upload-btn"
      :class="{ glow: inProgress }"
    >
      <span v-if="inProgress">Bezig met uploaden {{ uploadProgress }}%</span>
      <span v-else>Bestanden toevoegen</span>
    </uploader-btn>
  </section>
</template>

<script>
import SelectBox from '@/components/ui/SelectBox.vue'
import File from './filelist/File.vue'
import { sortBy } from 'lodash-es/collection'
import cloneDeep from 'lodash-es/cloneDeep'
import { useFileListStore } from '@/stores/FileList.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import PrintStoreProduct from './filelist/PrintStoreProduct.vue'

import { mapStores } from 'pinia'

export default {
  props: ['selectedFiles', 'uploadProgress', 'inProgress', 'standalone'],
  components: { SelectBox, File, PrintStoreProduct },
  mounted() {
    /*   if (this.visibleFilesList.length > 0 && this.selectedFiles.length < 1) {
      let fileToSelect = this.visibleFilesList.find((file) => {
        return (
          Object.keys(file.productSpecs).length === 0 && file.status === 'READY'
        )
      })
      if (fileToSelect) {
        this.$emit('select-file', fileToSelect, 'single')
      }
    } */
  },
  methods: {
    selectAll() {
      this.$emit('select-all')
    },
    selectFile(file, type) {
      if (file.status === 'ANALYZING') {
        return
      }
      this.$emit('select-file', file, type)
    },
    isSelected(file) {
      return this.selectedFiles.some((fl) => fl.fileName === file.fileName)
        ? true
        : false
    },
    updateQuantity(val) {
      const fileNames = this.selectedFiles.map((f) => f.fileName)
      this.fileListStore.updateProductOrderQuantity([fileNames, val])
    },
    setPrintStoreQuantity(val, index) {
      let newProducts = cloneDeep(this.printStoreProducts)
      newProducts[index].quantity = val

      this.printStoreStore.updateCart(newProducts)
    },
    removeProduct(product) {
      this.printStoreStore.removeFromCart(product)
    }
  },
  computed: {
    ...mapStores(useFileListStore, usePrintStoreStore),
    visibleFilesList() {
      return this.fileListStore.fileList.filter(
        (file) =>
          !file.inCart &&
          file.uploadFileType != 'ADDRESS_LIST' &&
          file.uploadFileType != 'ATTACHMENT_FILE'
      )
    },
    printStoreProducts() {
      return sortBy(this.printStoreStore.orderDetails.cart, ['fileName'])
    },
    headerText() {
      switch (this.visibleFilesList.length) {
        case 0:
          return 'Bestanden'
          break
        case 1:
          return '1 bestand'
          break
        default:
          return this.visibleFilesList.length + ' bestanden'
      }
    },
    allFilesSelected() {
      return this.visibleFilesList.length === this.selectedFiles.length &&
        this.selectedFiles.length > 0
        ? true
        : false
    }
  },
  watch: {
    /*  visibleFilesList: function (newV, oldV) {
      //only works with analyzed files, because 'newV.length === oldV.length', later....
      if (newV.length === oldV.length && this.selectedFiles.length === 0) {
        this.selectFile(newV[0], 'single')
      }
    } */
  }
}
</script>

<style lang="scss" scoped>
.glow {
  animation: pulse 1.5s infinite;
}
#file-list.mobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
#file-list {
  height: 615px;
  padding: 25px;
  transition: box-shadow 0.25s;
}

.add-btn {
  background-color: var(--arch-color);
  width: 100%;
  color: var(--arch-text-color);
  transition: 0.2s;
  padding: 0 4px;
  cursor: pointer;
  &:hover {
    background-color: var(--arch-color);
    //    box-shadow: var(--default-shadow);
  }
}

header {
  display: flex;
  align-items: center;
  padding-left: 15px;
  height: 19px;

  .select-box {
    margin-top: 0;
  }
}

.print-store-list {
  margin-top: 20px;
}

.ps-product {
  padding-bottom: 25px;
}

.select-all {
  flex-grow: 1;
  padding-left: 3px;
}

main {
  height: calc(100% - 64px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: -25px;
  margin-left: -25px;
  padding-top: 15px;
  padding-right: 25px;
  padding-left: 25px;

  &.no-files {
    height: calc(100% - 45px);
  }
}

.empty-list-message {
  display: block;
  text-align: center;
  padding: 15px;
  margin: 50px 0 15px;
  font-weight: 600;
  line-height: 20px;
  color: var(--action-color);
}

.empty-list-message-ps {
  display: block;
  text-align: center;
  padding: 15px;
  margin: -15px 0 20px;
  font-weight: 600;
  line-height: 20px;
  background: #f7f7f7;
  border-radius: 20px;
}

.scrolloverlay {
  position: sticky;
  height: 40px;
  background: linear-gradient(
    0deg,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  width: 100%;
  bottom: 0px;
  left: 0px;
  pointer-events: none;
}

.v-leave-active {
  transition: all 0.3s;
}
.v-leave-from {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}

.file-list li {
  container-type: inline-size;
}

@keyframes pulse {
  0% {
    box-shadow: var(--arch-color) 0px 0px 15px 5px;
  }
  50% {
    box-shadow: var(--arch-color) 0px 0px 15px -3px;
  }
  100% {
    box-shadow: var(--arch-color) 0px 0px 15px 5px;
  }
}
</style>
